let strapiEndpoint = process.env.STRAPI_URL
if (!strapiEndpoint) {
    strapiEndpoint = 'http://0.0.0.0:1337'
}

const today = new Date();
const isDropdown = (element) => element.hasAttribute('data-dropdown')
const selectDropdownButtons = () => document.querySelectorAll('[data-dropdown]')
const selectDropdown = (dropdownButton) =>
    document.getElementById(dropdownButton.getAttribute('data-dropdown'))
const triggerDropdown = (dropdown) => (dropdown.hidden = !dropdown.hidden)
const closeDropdown = (dropdown) => (dropdown.hidden = true)
const assignDropdownListener = (dropdownButton) =>
    dropdownButton.addEventListener('click', () =>
        triggerDropdown(selectDropdown(dropdownButton))
    )

selectDropdownButtons().forEach(assignDropdownListener)

var scrollToTopBtn = document.querySelector('.scrollToTopBtn')
var rootElement = document.documentElement

function handleScroll() {
    var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    if (rootElement.scrollTop / scrollTotal > 0.8) {
        scrollToTopBtn.classList.add('showBtn')
    } else {
        scrollToTopBtn.classList.remove('showBtn')
    }
}

function scrollToTop() {
    rootElement.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}
scrollToTopBtn && scrollToTopBtn.addEventListener('click', scrollToTop)
document.addEventListener('scroll', handleScroll)

let menuDishesElement = document.getElementById('menu-dishes')

function scrollToDish(e) {
    e.preventDefault()

    let target = document.getElementById(e.target.hash.substr(1))

    if (target) {
        let positionY = target.getBoundingClientRect().top
        let menuDishHeight = parseInt(
            window.getComputedStyle(menuDishesElement).height
        )
        console.log(menuDishHeight)
        window.scrollTo({
            top: window.pageYOffset + positionY - menuDishHeight,
            behavior: 'smooth',
        })
    }
}

if (menuDishesElement) {
    menuDishesElement
        .querySelectorAll('a.c-menu__dish')
        .forEach((menuDishElemenet) => {
            menuDishElemenet.addEventListener('click', scrollToDish)
        })
}

document.querySelectorAll('.c-nav__burger').forEach((ele) => {
    ele.addEventListener('click', () => {
        ele.classList.toggle('change')

        document.querySelectorAll('.c-nav__link').forEach((navEle) => {
            navEle.classList.toggle('is-active')
        })
    })
})

let dailyMenuElement = document.getElementById('daily-menu')

if (dailyMenuElement) {
    const addDivider = () => {
        const dividerEle = document.createElement('div')
        dividerEle.className = 'o-divider'

        dailyMenuElement.appendChild(dividerEle)
    }

    const appendHeading = (title) => {
        const headingEle = document.createElement('h2')
        headingEle.className = 'c-menu__heading c-menu__heading--border-fit'
        headingEle.textContent = title

        dailyMenuElement.appendChild(headingEle)
    }

    const clearMenu = () => {
        dailyMenuElement.innerHTML = ''
    }

    const appendItem = (name, price, description) => {
        const itemEle = document.createElement('div')
        itemEle.className = 'c-menu__item'
        const descriptionListEle = document.createElement('div')
        const nameEle = document.createElement('p')
        nameEle.className = 'c-menu__food-heading'
        nameEle.textContent = name
        const descEle = document.createElement('p')
        descEle.className = 'c-menu__food-heading c-menu__food-heading--side'
        descEle.textContent = description
        descriptionListEle.append(nameEle, descEle)
        const priceEle = document.createElement('p')
        priceEle.className = 'c-menu__food-heading c-menu__food-heading--price'
        priceEle.textContent = price
        itemEle.append(descriptionListEle, priceEle)

        dailyMenuElement.appendChild(itemEle)
    }

    const renderMenu = (menu) => {
        let prevItemWasSection = null

        clearMenu();

        for (let item of menu.Items) {
            const isSection = item['__component'] === 'menu.section'

            if (prevItemWasSection === true && !isSection) {
                addDivider()
            }

            if (isSection) {
                appendHeading(item.Name)

                item.Item.forEach((sectionItem) =>
                    appendItem(
                        sectionItem.Name,
                        sectionItem.Price,
                        sectionItem.Description
                    )
                )
            } else {
                appendItem(item.Name, item.Price, item.Description)
            }

            prevItemWasSection = isSection
        }
    }

    const renderEmptyMenu = () => {
        clearMenu();
    }

    const fetchMenu = (date) => {
        console.log(date);
        const dateStr = date.toISOString().substr(0, 10)

        const dailyMenuHeadingEle = document.getElementById('daily-menu-heading')

        if (dailyMenuHeadingEle) {
            dailyMenuHeadingEle.textContent = `Denní menu - ${date.getDate()}. ${date.getMonth() + 1}.`
        }

        fetch(`${strapiEndpoint}/menus?Date=${dateStr}`).then((resp) => {
            resp.json().then((data) => {
                const menu = data[0]

                if (menu) {
                    renderMenu(menu)
                } else {
                    renderEmptyMenu()
                }
            })
        })
    }

    const menuDateInput = document.getElementById('menu-date-input');

    const getDate = () => {
        let dateVal = undefined;
        const params = new URLSearchParams(location.search);

        if (params.has('date')) {
            const date = Date.parse(params.get('date'))

            if (date) {
                dateVal = date
            }
        }

        return dateVal ? new Date(dateVal) : today;
    }

    const setDateInUrl = (date) => {
        const params = new URLSearchParams(location.search)
        if (date) {
            const dateStr = date.toISOString().substr(0, 10)
            params.set('date', dateStr)
            window.history.pushState({}, '', `?${params.toString()}`)
        } else {
            window.history.pushState({}, '', location.pathname)
        }
    }

    const updateDate = () => {
        const dateVal = Date.parse(menuDateInput.value);
        const date = dateVal ? new Date(dateVal) : today;

        if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
            console.log('remove');
            setDateInUrl(null)
        } else {
            setDateInUrl(date)
        }

        fetchMenu(getDate());
    }


    if (menuDateInput) {
        menuDateInput.addEventListener('change', updateDate);
        menuDateInput.value = getDate().toISOString().substr(0, 10);

        fetchMenu(getDate());
    }
}
